import {IntermediatePart} from "../../intermediatePart";
import Appliance from "../../parts/appliance";
import CountertopGroup from "../../parts/countertopGroup";
import {METADATA} from "../../constants";

export default class BottomHandle extends IntermediatePart {

  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'bottom_handle';
    this.partName = 'Bottom Handle';
    this.translateId = "visualizer.kitchen.cabinet.bottom_handle";
    this.canBeDisabled = true;
    this.layerPriority = 5;
    this.hasAdditionalParts = true;
  }

  load(dbFeature) {
    if (Array.isArray(dbFeature.metaData["MountType"]) && dbFeature.metaData["MountType"][0] === "0") {
      if (!dbFeature.metaData["MountType"].includes("FM")) {
        dbFeature.metaData["MountType"].push("FM")
      }
      if (!dbFeature.metaData["MountType"].includes("ST")) {
        dbFeature.metaData["MountType"].push("ST")
      }
    }
    if (dbFeature.metaData["RoomLayout"]
      && (dbFeature.metaData["RoomLayout"].includes("Layout3") || dbFeature.metaData["RoomLayout"].includes("3"))) {
      // if (!dbFeature.metaData["MountType"].includes("U")) {
      //   dbFeature.metaData["MountType"].push("U")
      // }
      // if (!dbFeature.metaData["MountType"].includes("S")) {
      //   dbFeature.metaData["MountType"].push("S")
      // }
      dbFeature.metaData["MountType"] = METADATA.ALL
    }
    if (!dbFeature.metaData["Stovetop"]) {
      dbFeature.metaData["Stovetop"] = METADATA.NO
    }
    const partNumber = (dbFeature.metaData["Part"] && dbFeature.metaData["Part"][0]) === "1" ? 1 : 2;
    return super.load_(dbFeature, new BottomHandle(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  handleClick(ignoreLocked, clickFrom = "") {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick(ignoreLocked, clickFrom);
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.bottomHandle.activeFeature = this;
    }
    this.featureClicked();
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const cabinetParent = this.getParent();
    const countertopParent = cabinetParent.layout.parts[CountertopGroup.id];
    // const applianceParent = cabinetParent.layout.parts[Appliance.id];
    conditions.push({
      propName: "MountType",
      propValue: countertopParent && countertopParent.sink && countertopParent.sink.activeFeature
      && !countertopParent.sink.disabled && countertopParent.sink.featureGroupEnabled
        ? countertopParent.sink.activeFeature.metaData["MountType"]
        : ["U"]
    });
    return conditions
  }

  getActiveFeatureConditions() {
    return this.getArrayOfConditions().filter(metaObject => {
      return metaObject.propName !== "MountType"
    })
  }

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);

      const cabinetParent = this.getParent();
      const applianceParent = cabinetParent.layout.parts[Appliance.id];

      //part 1 will be with MountType
      // part 2 dishwasher - depends on dishwasher metaData Width
      //part 3 depends on stove metaData Width // on Room Layout 6 we have Range + Stovetop, not Stove
      // part 4 - fridge
      // part 5 - peninsula

      let withStoveConditions = [...arrayOfConditions];
      const rangeIsActive = applianceParent && applianceParent.range && !applianceParent.range.disabled && applianceParent.range.activeFeature;
      if (applianceParent && applianceParent.layout.type === 6) {
        withStoveConditions.push({
          propName: "Stovetop",
          propValue: rangeIsActive ? METADATA.NO : "ST",
        });
      }
      withStoveConditions.push({
        propName: "Width",
        propValue: rangeIsActive
          ? applianceParent.range.activeFeature.metaData["Width"] || "30"
          : applianceParent
          && applianceParent.stove
          && applianceParent.stove.activeFeature
          && applianceParent.stove.activeFeature.metaData["Width"]
            ? applianceParent.stove.activeFeature.metaData["Width"]
            : "30"
      })
      const withDishWasherConditions = [...arrayOfConditions, {
        propName: "Width",
        propValue: applianceParent && applianceParent.dishwasher && applianceParent.dishwasher.activeFeature
        && applianceParent.dishwasher.activeFeature.metaData["Width"]
          ? applianceParent.dishwasher.activeFeature.metaData["Width"]
          : "24",
      }];
      const withFridgeConditions = [...arrayOfConditions, {
        propName: "Width",
        propValue: applianceParent && applianceParent.fridge && applianceParent.fridge.activeFeature
        && applianceParent.fridge.activeFeature.metaData["Width"]
          ? applianceParent.fridge.activeFeature.metaData["Width"]
          : "36",
      }];
      activeFeatureParts = this.featuresParts.filter((feature) => {
        if (name1 !== feature.getSplittedFeatureName()) {
          return false
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")) {
          return feature.matchesMetaForArrayOfConditions(withDishWasherConditions)
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("3")) {
          return feature.matchesMetaForArrayOfConditions(withStoveConditions)
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("4")) {
          return feature.matchesMetaForArrayOfConditions(withFridgeConditions)
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("5")) {
          if (!applianceParent || !applianceParent.oven || applianceParent.oven.disabled || !applianceParent.oven.activeFeature) {
            return false
          }
        }
        return feature.matchesMetaForArrayOfConditions(arrayOfConditions)
      });

      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      activeFeatureParts = activeFeatureParts.reduce((finalParts, activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled;
        if (!finalParts.some(featurePart => {
          const partA = featurePart.metaData["Part"];
          const partB = activeFeaturePart.metaData["Part"];
          if (!partA && !partB) return true;
          if (!partA || !partB) return false;
          return partA[0] === partB[0];
        })) {
          finalParts.push(activeFeaturePart)
        }
        return finalParts
      }, []);
    }
    return activeFeatureParts
  }
}
